<script setup lang="ts">
import { computed } from 'vue'

import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'ImportSalesTaxHeader',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  {
    id: 'import-sales-tax',
    text: 'Import SalesTax',
    to: AppRoute.ImportSalesTax,
    disabled: true,
  },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
